// ───────────────────────────────────────────────────────────────────────────
// Playbook catalog + article registry.
//
// CATALOG  — the left-rail grouping. Single source of truth for order, labels,
//            tier (free/pro) and beta flags. Icons are mapped in Playbook.jsx.
// ARTICLES — slug → article data. A slug present in CATALOG but absent here
//            renders the "article in progress" empty state automatically.
//
// To add an article: create ./<slug>.js (see ./_template.js), import it below,
// and register it in ARTICLES. No other wiring needed.
// ───────────────────────────────────────────────────────────────────────────

import adsTxt from './ads-txt';
import sellersJson from './sellers-json';
import schain from './schain';
import bidRequest from './bid-request';
import crawler from './crawler';
import bundles from './bundles';
import bundleLookup from './bundle-lookup';
import appCategory from './app-category';
import discrepancy from './discrepancy';
import discMonitor from './disc-monitor';
import fetchEngine from './fetch-engine';
import industryPulse from './industry-pulse';

export const CATALOG = [
  {
    group: 'Supply chain & authorization',
    items: [
      { slug: 'ads-txt',      label: 'Ads.txt Checker',       tier: 'free' },
      { slug: 'sellers-json', label: 'Sellers.json Checker',  tier: 'pro'  },
      { slug: 'schain',       label: 'Schain Validator',      tier: 'pro'  },
      { slug: 'bid-request',  label: 'Bid Request Analyzer',  tier: 'pro'  },
    ],
  },
  {
    group: 'Inventory & apps',
    items: [
      { slug: 'crawler',       label: 'Crawler',        tier: 'pro' },
      { slug: 'bundles',       label: 'Bundle Tracker', tier: 'pro' },
      { slug: 'bundle-lookup', label: 'Bundle Lookup',  tier: 'pro' },
      { slug: 'app-category',  label: 'App Category',   tier: 'pro' },
    ],
  },
  {
    group: 'Reconciliation & monitoring',
    items: [
      { slug: 'discrepancy',  label: 'Discrepancy Checker', tier: 'pro' },
      { slug: 'disc-monitor', label: 'Discrepancy Monitor', tier: 'pro', beta: true },
      { slug: 'fetch-engine', label: 'Fetch Engine',        tier: 'pro', beta: true },
    ],
  },
  {
    group: 'Intelligence',
    items: [
      { slug: 'industry-pulse', label: 'Industry Pulse', tier: 'free' },
    ],
  },
];

export const ARTICLES = {
  'ads-txt': adsTxt,
  'sellers-json': sellersJson,
  'schain': schain,
  'bid-request': bidRequest,
  'crawler': crawler,
  'bundles': bundles,
  'bundle-lookup': bundleLookup,
  'app-category': appCategory,
  'discrepancy': discrepancy,
  'disc-monitor': discMonitor,
  'fetch-engine': fetchEngine,
  'industry-pulse': industryPulse,
};
